module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-Italic-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-Italic-webfont.eot
// module id = 357
// module chunks = 0